import React from "react";
import { Link } from "react-router-dom";
import { Code, Smartphone, Users, GraduationCap } from "lucide-react";
import SEO from '../components/SEO';
import { Helmet } from 'react-helmet-async';
import productionBase from '../config/SEOConfig';



const title="Custom Software Development Services | AKHSoft";
const description = "AKHSoft provides custom software development, enterprise mobile apps, collaboration platforms, and e-learning solutions tailored to drive digital transformation.";
const keywords = "Custom Software Development, Enterprise Software Solutions, Business Software, Software Company Pakistan, Mobile App Development, Web Application Development, ERP Software Development, Software Solutions for Businesses, AKHSoft, Scalable Software, Digital Transformation, Web Development Company, Custom ERP Systems";
const path = typeof window !== "undefined" ? window.location.pathname : "";

export default function SoftwareDevelopment() {
  return (
    <>
   <SEO 
      title={title}
      description={description}
      keywords={keywords}
      path={path}
    />
    <div className="max-w-7xl mx-auto px-6 py-14 space-y-20 text-gray-800">
      {/* Hero */}
      <section className="text-center space-y-5">
        <h1 className="text-4xl md:text-5xl font-bold text-[#0a3c6d]">
         Custom Software Development Services for Modern Businesses
        </h1>
        <p className="text-lg max-w-3xl mx-auto text-gray-600">
          At AKHSoft, we engineer powerful, scalable, and custom digital solutions tailored to elevate your business efficiency and growth.
        </p>
      </section>

      {/* Services */}
      <section className="grid md:grid-cols-2 gap-10">
        {/* Custom Software Development */}
        <div className="p-8 bg-white border shadow rounded-2xl hover:shadow-lg transition">
          <div className="mb-4 text-[#0a3c6d]">
            <Code size={40} />
          </div>
          <h3 className="text-2xl font-semibold text-[#0a3c6d] mb-2">
            Custom Software Development
          </h3>
          <p className="text-gray-600 mb-4">
            We develop bespoke software solutions tailored to your business workflows. Whether it's a CRM, inventory system, or process automation, our solutions are robust, scalable, and future-proof.
          </p>
          <Link to="/software-development/custom-software-development" className="text-[#0a3c6d] font-medium hover:underline">
            Learn More →
          </Link>
        </div>

        {/* Enterprise Mobile Applications */}
        <div className="p-8 bg-white border shadow rounded-2xl hover:shadow-lg transition">
          <div className="mb-4 text-[#0a3c6d]">
            <Smartphone size={40} />
          </div>
          <h3 className="text-2xl font-semibold text-[#0a3c6d] mb-2">
            Enterprise Mobile Applications
          </h3>
          <p className="text-gray-600 mb-4">
            Empower your workforce and customers with powerful mobile applications. Our mobile apps are optimized for performance, security, and seamless user experience across Android and iOS.
          </p>
          <Link to="/software-development/enterprise-mobile-applications" className="text-[#0a3c6d] font-medium hover:underline">
            Learn More →
          </Link>
        </div>

        {/* Online Collaboration Platforms */}
        <div className="p-8 bg-white border shadow rounded-2xl hover:shadow-lg transition">
          <div className="mb-4 text-[#0a3c6d]">
            <Users size={40} />
          </div>
          <h3 className="text-2xl font-semibold text-[#0a3c6d] mb-2">
            Online Collaboration Platforms
          </h3>
          <p className="text-gray-600 mb-4">
            Streamline internal and external communication with real-time collaboration tools. We build chat, task management, document sharing, and video conferencing systems customized to your team’s workflow.
          </p>
          <Link to="/software-development/online-collaboration-platform" className="text-[#0a3c6d] font-medium hover:underline">
            Learn More →
          </Link>
        </div>

        {/* Digital Learning Solutions */}
        <div className="p-8 bg-white border shadow rounded-2xl hover:shadow-lg transition">
          <div className="mb-4 text-[#0a3c6d]">
            <GraduationCap size={40} />
          </div>
          <h3 className="text-2xl font-semibold text-[#0a3c6d] mb-2">
            Digital Learning Solutions
          </h3>
          <p className="text-gray-600 mb-4">
            Deliver knowledge at scale with intuitive e-learning platforms. We design LMS solutions with interactive modules, progress tracking, assessments, and mobile compatibility for educational institutions and enterprises.
          </p>
          <Link to="/software-development/online-learning-solutions" className="text-[#0a3c6d] font-medium hover:underline">
            Learn More →
          </Link>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#0a3c6d] text-white py-12 rounded-2xl text-center shadow-lg">
        <h3 className="text-3xl font-bold mb-3">
          Ready to Build Custom Software That Scales?
        </h3>
        <p className="text-lg mb-6 max-w-xl mx-auto">
        Partner with AKHSoft to design custom software, web, or mobile apps tailored to your business goals. Let’s build your digital success story together.
        </p>
        <Link
          to="/contact-us"
          className="inline-block px-6 py-3 bg-white text-[#0a3c6d] rounded-full font-semibold hover:bg-gray-200 transition"
        >
          Get Started Today
        </Link>
      </section>
    </div>
    </>
  );
}
